import React from 'react';

import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import api from '~/services/api';

import { Card } from './components';
import * as S from './styles';

export default function EstoquePostoMonitor() {
  function handleOpennewWindow() {
    const windowRef = window.open(
      'dlgEstoquePostoMonitor_fullscreen',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );

    const receiveReadyMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data.type === 'READY') {
        // Recebe a confirmacao da prontidao da janela maximizada
        const auth = {
          token: api.defaults.headers.token,
          signed: true,
          loading: false,
        };
        windowRef.postMessage({ auth }, window.location.origin);
        window.removeEventListener('message', receiveReadyMessage);
      }
    };

    window.addEventListener('message', receiveReadyMessage);
  }

  return (
    <S.Wrapper>
      <S.Header>
        <IconButton
          aria-label="Abrir nova janela"
          onClick={handleOpennewWindow}
        >
          <OpenInNew />
        </IconButton>
      </S.Header>
      <Card />
    </S.Wrapper>
  );
}
